
/**
 * @author Camilo
 * @since  25/10/2018
 */
export class ConsultarEstadoFacturaModel{

constructor(public EMISOR:string,
            public NITEMISOR:string,	
            public NEGOCIO:string,	
            public PREFIJO:string,	
            public NUMERO_DOCUMENTO:string,	
            public FECHA_FACTURA:string,	
            public ESTADO_ENVIO_CENF:string,	
            public MENSAJE_RESPUESTA_CARVAJAL:string,	
            public VALIDACION_DIAN:string,	
            public MENSAJE_RESPUESTA_DIAN:string){}

}


// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/FacturacionElectronicaConsultarEstadoFactura/ConsultarEstadoFactura.model.ts